import { FC } from "react";
import { usePergola } from "../../data-stores/pergola";
import { formatPrice } from "../../price-calculations/format-price";

export interface DiscountBadgeProps {
  discount: number;
}

export const DiscountBadge: FC<DiscountBadgeProps> = ({
  discount: discountProp,
}): JSX.Element | null => {
  const discountFromStore = usePergola((state) => state.discount);
  const discount =
    discountProp !== undefined ? discountProp : discountFromStore;

  if (discount <= 0) {
    return null;
  }

  return (
    <div className="flex items-center bg-[#f4ffe2] py-[3px] px-[13px] rounded-md w-fit">
      <p className="font-bold text-sm leading-[1.35] text-green text-right m-0 whitespace-nowrap">
        {formatPrice(discount)} Saved
      </p>
    </div>
  );
};
